module.exports = __webpack_public_path__ + "img/Flag_of_Guinea.a783ea88.svg";